<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script setup lang="ts">
import { watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { useAppDataStore } from '@/stores/appdata.ts'
import { useDepartmentsStore } from '@/stores/departments/departments.ts'

import Header from '@/components/header/Header.vue'
import AppWrapper from './AppWrapper.vue'

const appdata = useAppDataStore()
const departmentStore = useDepartmentsStore()

void appdata.fetchAppData()
void departmentStore.fetchAll()

const { t, te } = useI18n()
const route = useRoute()
watchEffect(() => {
  const titleStringKey =
    typeof route.name === 'string' && te(`title.${route.name}`) ? `title.${route.name}` : 'title.base'
  document.title = t(titleStringKey, t('title.base'), { missingWarn: false })
})
</script>

<template>
  <div v-if="!appdata.loaded">
    <!-- TODO: Some loading state, maybe a big flop logo with clock spinning and changing colors? -->
  </div>
  <AppWrapper v-else>
    <Header />
    <main>
      <RouterView />
    </main>
  </AppWrapper>
</template>
